import { useContext, useCallback } from 'react';
import { TranslationContext } from '../contexts/translation';

const useTranslation = () => {
  const translations = useContext(TranslationContext);
  return useCallback(
    (key) => {
      if (translations) {
        return Object.keys(translations).length && translations[key] ? translations[key] : key;
      }
      return null;
    },
    [translations]
  );
};

export default useTranslation;
